/**
 * Auto-kit-bougies
 * 
 * Ce script ajoute automatiquement un kit d'entretien des bougies
 * lorsqu'une bougie éligible est ajoutée au panier
 * - Protection anti-triche incluse
 */

// if (false) {

(function() {
  // Configuration
  const config = {
    kitHandle: 'kit-entretien-bougies-offert',
    bougiesEligibles: [
      'bougie-nuit-a-paris-500gr',
      'bougie-aventure-riviera-500gr',
      'bougie-aventure-riviera-500',
      'bougie-aventure-riviera',
      'bougie-week-end-a-aspen-500gr'
    ],
    debug: false,
    checkoutBlockDelay: 300 // Délai avant de débloquer le checkout (ms)
  };

  // Éviter les appels multiples rapprochés
  let isSynchronizing = false;
  let lastSyncTime = 0;
  let syncTimeoutId = null;
  let kitsNeedSync = false;

  // Fonction de log conditionnelle
  function log(...args) {
    if (config.debug) console.log(...args);
  }

  // Masquer les contrôles de quantité pour le kit
  function hideKitQuantityControls() {
    // Cibler spécifiquement les éléments du panier
    document.querySelectorAll('.line-item').forEach(item => {
      // Vérifier si c'est le kit d'entretien
      const titleElement = item.querySelector('.line-item__title');
      if (titleElement && titleElement.textContent.toLowerCase().includes(config.kitHandle.replace(/-/g, ' '))) {
        // Masquer le prix (mettre à 0,00€)
        const priceElement = item.querySelector('.line-item__price');
        if (priceElement) {
          priceElement.textContent = '0,00€';
        }

        // Remplacer le sélecteur de quantité par un texte simple
        const quantitySelector = item.querySelector('.quantity-selector');
        if (quantitySelector) {
          const quantity = quantitySelector.querySelector('input[type="text"]').value;
          const quantityContainer = document.createElement('div');
          quantityContainer.style.marginTop = '0.75rem';
          
          const quantityText = document.createElement('span');
          quantityText.textContent = `Quantité: ${quantity}`;
          quantityText.style.color = 'rgb(var(--text-color))';
          quantityText.style.fontSize = 'calc(var(--base-text-font-size) - 1px)';
          
          quantityContainer.appendChild(quantityText);
          quantitySelector.parentNode.replaceChild(quantityContainer, quantitySelector);
        }

        // Supprimer le bouton "Supprimer"
        const removeButton = item.querySelector('.line-item__remove-button');
        if (removeButton) {
          removeButton.style.display = 'none';
        }

        // Supprimer toutes les propriétés de ligne
        const propertiesList = item.querySelector('.line-item__property-list');
        if (propertiesList) {
          propertiesList.remove();
        }
      }
    });
  }

  // Observer les changements dans le panier pour masquer les contrôles
  function observeCartChanges() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          setTimeout(hideKitQuantityControls, 0);
        }
      }
    });

    // Observer le drawer-cart et le cart-page
    ['cart-drawer', 'main'].forEach(containerId => {
      const container = document.getElementById(containerId);
      if (container) {
        observer.observe(container, { 
          childList: true, 
          subtree: true,
          characterData: true,
          attributes: true
        });
      }
    });

    // Appliquer immédiatement
    hideKitQuantityControls();
  }

// Vérifier si le produit kit existe
fetch(`/products/${config.kitHandle}.js`)
  .then(response => {
    if (!response.ok) {
      if (response.status === 404) {
        log(`⚠️ ATTENTION: Le produit '${config.kitHandle}' n'existe pas dans la boutique. Le script ne fonctionnera pas correctement.`);
        console.error(`Le produit '${config.kitHandle}' n'existe pas dans la boutique. Veuillez créer ce produit ou mettre à jour le handle dans le script.`);
      } else {
        log(`⚠️ Erreur lors de la vérification du produit kit: ${response.status}`);
      }
      return;
    }

    // ✅ Appel de la fonction principale ici
    initAutoKitBougies();

  })
  .catch(error => {
    log(`❌ Erreur lors de la vérification du produit kit:`, error);
  });
    
  // Fonction pour obtenir les données du kit
  let kitProduct = null;
  async function getKitProduct() {
    if (kitProduct) return kitProduct;
    
    try {
      const response = await fetch(`/products/${config.kitHandle}.js`);
      if (!response.ok) throw new Error(`Erreur ${response.status}`);
      kitProduct = await response.json();
      return kitProduct;
    } catch (error) {
      log(`❌ Erreur lors de la récupération du produit kit:`, error);
      return null;
    }
  }

  // Calculer la quantité totale de bougies éligibles
  function calculateTotalBougiesQuantity(cartItems) {
    return cartItems.reduce((total, item) => {
      if (config.bougiesEligibles.includes(item.handle)) {
        return total + item.quantity;
      }
      return total;
    }, 0);
  }

  // Bloquer temporairement les boutons de checkout
  function blockCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll('a[href="/checkout"], button[name="checkout"], [href*="checkout"], [onclick*="checkout"]');
    for (let i = 0; i < checkoutButtons.length; i++) {
      const button = checkoutButtons[i];
      if (!button.hasAttribute('data-original-onclick')) {
        button.setAttribute('data-original-onclick', button.getAttribute('onclick') || '');
        button.setAttribute('data-original-href', button.getAttribute('href') || '');
      }
      
      button.setAttribute('onclick', 'return false');
      button.setAttribute('href', 'javascript:void(0)');
      button.classList.add('kit-sync-in-progress');
    }
  }
  
  // Débloquer les boutons de checkout
  function unblockCheckoutButtons() {
    setTimeout(() => {
      const checkoutButtons = document.querySelectorAll('.kit-sync-in-progress');
      for (let i = 0; i < checkoutButtons.length; i++) {
        const button = checkoutButtons[i];
        const originalOnclick = button.getAttribute('data-original-onclick');
        const originalHref = button.getAttribute('data-original-href');
        
        if (originalOnclick) button.setAttribute('onclick', originalOnclick);
        if (originalHref) button.setAttribute('href', originalHref);
        
        button.classList.remove('kit-sync-in-progress');
      }
    }, config.checkoutBlockDelay);
  }

  // Synchroniser le panier pour s'assurer que le kit est présent
  async function synchronizeCart() {
    // Éviter les appels multiples rapprochés
    const now = Date.now();
    if (isSynchronizing || now - lastSyncTime < 200) {
      log('⏱️ Synchronisation déjà en cours ou trop récente, ignorée');
      kitsNeedSync = true;
      return;
    }

    isSynchronizing = true;
    lastSyncTime = now;
    kitsNeedSync = false;
    
    try {
      // Bloquer temporairement le checkout pendant la synchronisation
      blockCheckoutButtons();
      
      // Récupérer le panier actuel
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      if (!cart.items || cart.items.length === 0) {
        isSynchronizing = false;
        unblockCheckoutButtons();
        return;
      }
      
      // Calculer la quantité totale de bougies éligibles
      const totalBougiesQuantity = calculateTotalBougiesQuantity(cart.items);
      
      // Vérifier si une bougie éligible est présente
      if (totalBougiesQuantity === 0) {
        log('❌ Aucune bougie éligible trouvée dans le panier');
        
        // Si le kit est présent, le supprimer
        const kitInCart = cart.items.find(item => item.handle === config.kitHandle);
        if (kitInCart) {
          log('🗑️ Suppression du kit car plus aucune bougie éligible');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: kitInCart.key,
              quantity: 0
            })
          });

          // Rafraîchir l'affichage du panier après la suppression
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'kit:sync',
              cart: await (await fetch('/cart.js')).json()
            }
          }));
          
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
        
        isSynchronizing = false;
        unblockCheckoutButtons();
        return;
      }
      
      // Récupérer le produit kit et ses variantes
      const kitProduct = await getKitProduct();
      if (!kitProduct) {
        isSynchronizing = false;
        unblockCheckoutButtons();
        return;
      }
      
      // Vérifier si le kit est déjà dans le panier
      const kitInCart = cart.items.find(item => item.handle === config.kitHandle);
      
      if (!kitInCart) {
        // Ajouter le kit au panier
        log('🔄 Ajout du kit d\'entretien au panier');
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: kitProduct.variants[0].id,
            quantity: totalBougiesQuantity,
            properties: {
              _kit_offert: "Offert avec votre bougie"
            }
          })
        });
        
        if (!response.ok) {
          throw new Error(`Erreur ${response.status} lors de l'ajout du kit`);
        }
      } else if (kitInCart.quantity !== totalBougiesQuantity) {
        // Mettre à jour la quantité du kit
        log(`🔄 Mise à jour de la quantité du kit: ${totalBougiesQuantity}`);
        
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: kitInCart.key,
            quantity: totalBougiesQuantity
          })
        });
      }
      
      // Rafraîchir l'affichage du panier
      const updatedCartResponse = await fetch('/cart.js');
      const updatedCart = await updatedCartResponse.json();
      
      // Déclencher les événements pour mettre à jour l'UI
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'kit:sync',
          cart: updatedCart
        }
      }));
      
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      log('🔄 Panier rafraîchi après synchronisation du kit');
      
      // Masquer les contrôles de quantité
      setTimeout(hideKitQuantityControls, 100);
      
    } catch (error) {
      log('❌ Erreur lors de la synchronisation du panier:', error);
    } finally {
      // S'assurer que le flag est réinitialisé même en cas d'erreur
      isSynchronizing = false;
      unblockCheckoutButtons();
      
      // Vérifier si une autre synchronisation est nécessaire
      if (kitsNeedSync) {
        scheduleSynchronization(100);
      }
    }
  }

  // Fonction pour planifier la synchronisation avec délai minimal
  function scheduleSynchronization(delay = 0) {
    // Annuler toute synchronisation déjà planifiée
    if (syncTimeoutId) {
      clearTimeout(syncTimeoutId);
    }
    
    // Planifier une nouvelle synchronisation
    syncTimeoutId = setTimeout(() => {
      synchronizeCart();
      syncTimeoutId = null;
    }, delay);
  }

  // Vérifier si le panier est équilibré (nombre correct de kits)
  async function validateCartBeforeCheckout() {
    log('🔍 Vérification du panier avant le checkout');
    
    try {
      // Obtenir l'état actuel du panier
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      if (!cart.items || cart.items.length === 0) return true;
      
      // Calculer la quantité totale de bougies éligibles
      const totalBougiesQuantity = calculateTotalBougiesQuantity(cart.items);
      
      // Vérifier si le kit est présent dans le panier
      const kitInCart = cart.items.find(item => item.handle === config.kitHandle);
      
      // Si pas de bougies, pas besoin de kit
      if (totalBougiesQuantity === 0) {
        // Si un kit est présent, le supprimer
        if (kitInCart) {
          log('🧹 Suppression du kit car aucune bougie éligible n\'est présente');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: kitInCart.key,
              quantity: 0
            })
          });
          
          // Rafraîchir l'affichage du panier
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'kit:sync'
            }
          }));
          
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return false; // Bloquer le checkout pour permettre la mise à jour de l'UI
        }
        return true; // Panier OK, pas de bougies donc pas de kit nécessaire
      }
      
      // Si des bougies sont présentes mais pas de kit, en ajouter un
      if (totalBougiesQuantity > 0 && !kitInCart) {
        log('🔄 Ajout du kit manquant avant checkout');
        await synchronizeCart();
        return false; // Bloquer le checkout pour permettre la mise à jour
      }
      
      // Si la quantité de kits ne correspond pas à la quantité de bougies
      if (kitInCart && kitInCart.quantity !== totalBougiesQuantity) {
        log(`🔄 Correction de la quantité du kit: ${kitInCart.quantity} → ${totalBougiesQuantity}`);
        
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: kitInCart.key,
            quantity: totalBougiesQuantity
          })
        });
        
        // Rafraîchir l'affichage du panier
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'kit:sync'
          }
        }));
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        // Afficher message de correction
        showCartCorrectionMessage();
        return false; // Bloquer le checkout pour permettre la mise à jour
      }
      
      // NOUVEAU: Détection des tentatives de manipulation du prix
      if (kitInCart) {
        // Vérifier que le prix du kit est bien à 0
        if (parseFloat(kitInCart.price) !== 0) {
          log(`⚠️ Tentative de manipulation du prix du kit détectée! Prix: ${kitInCart.price}`);
          
          // Forcer une resynchronisation complète
          await synchronizeCart();
          showSecurityAlert("Tentative de modification détectée", "Le panier a été réinitialisé pour des raisons de sécurité.");
          return false;
        }
        
        // Vérifier que les propriétés du kit sont présentes et correctes
        if (!kitInCart.properties || !kitInCart.properties._kit_offert) {
          log(`⚠️ Tentative de manipulation des propriétés du kit détectée!`);
          
          // Forcer une resynchronisation complète
          await synchronizeCart();
          showSecurityAlert("Tentative de modification détectée", "Le panier a été réinitialisé pour des raisons de sécurité.");
          return false;
        }
      }
      
      return true; // Le panier est valide
    } catch (error) {
      log('❌ Erreur lors de la validation du panier:', error);
      return true; // En cas d'erreur, permettre le checkout
    }
  }
  
  // Afficher un message d'alerte au client
  function showCartCorrectionMessage() {
    // Création du message
    const messageContainer = document.createElement('div');
    messageContainer.className = 'kit-correction-message';
    messageContainer.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #f8d7da;
      color: #721c24;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      z-index: 9999;
      text-align: center;
      max-width: 300px;
      font-size: 14px;
    `;
    
    messageContainer.innerHTML = `
      <p>Votre panier a été ajusté pour correspondre au nombre correct de kits d'entretien offerts.</p>
      <button style="background: #721c24; color: white; border: none; padding: 5px 10px; margin-top: 8px; border-radius: 4px; cursor: pointer;">OK</button>
    `;
    
    // Ajouter au DOM
    document.body.appendChild(messageContainer);
    
    // Fermer le message au clic
    messageContainer.querySelector('button').addEventListener('click', () => {
      messageContainer.remove();
    });
    
    // Auto-fermeture après 8 secondes
    setTimeout(() => {
      if (document.body.contains(messageContainer)) {
        messageContainer.remove();
      }
    }, 8000);
  }

  // NOUVEAU: Alerte de sécurité plus sévère
  function showSecurityAlert(title, message) {
    // Création du message
    const messageContainer = document.createElement('div');
    messageContainer.className = 'security-alert-message';
    messageContainer.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #721c24;
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      z-index: 9999;
      text-align: center;
      max-width: 300px;
      font-size: 14px;
    `;
    
    messageContainer.innerHTML = `
      <p style="font-weight: bold; margin: 0 0 8px 0;">${title}</p>
      <p style="margin: 0;">${message}</p>
      <button style="background: white; color: #721c24; border: none; padding: 5px 10px; margin-top: 12px; border-radius: 4px; cursor: pointer; font-weight: bold;">OK</button>
    `;
    
    // Ajouter au DOM
    document.body.appendChild(messageContainer);
    
    // Fermer le message au clic
    messageContainer.querySelector('button').addEventListener('click', () => {
      messageContainer.remove();
    });
    
    // Auto-fermeture après 10 secondes
    setTimeout(() => {
      if (document.body.contains(messageContainer)) {
        messageContainer.remove();
      }
    }, 10000);
  }

  // Gestionnaire d'événement pour les ajouts au panier
  function handleProductAdded(event) {
    log('🔄 Événement variant:add détecté pour l\'ajout au panier');
    log('📦 Détails de l\'événement:', event.detail);
    
    // Synchroniser le panier rapidement
    scheduleSynchronization(100);
  }
  
  // Gestionnaire d'événement pour les changements de panier
  function handleCartChange(event) {
    // Ne pas réagir aux événements que nous avons déclenchés nous-mêmes
    if (event.detail.baseEvent === 'kit:sync') {
      log('🔄 Événement cart:change ignoré (déclenché par nous-mêmes)');
      return;
    }
    
    // NOUVEAU: Ignorer les événements liés aux échantillons gratuits
    // Cela évite une boucle d'animation infinie lors de l'ajout/suppression d'échantillons
    if (event.detail && event.detail.baseEvent === 'sample:change') {
      log('🔄 Événement cart:change ignoré (échantillon gratuit)');
      return;
    }
    
    // Vérifier si l'événement concerne un échantillon gratuit
    if (event.detail && event.detail.item && 
        (event.detail.item.handle === 'echantillon-gratuit' || 
         (event.detail.item.properties && event.detail.item.properties._echantillon_gratuit === 'true'))) {
      log('🔄 Événement cart:change ignoré (échantillon gratuit détecté)');
      return;
    }
    
    log('🔄 Événement cart:change détecté');
    log('📦 Détails de l\'événement:', event.detail);
    
    // Synchroniser le panier immédiatement après une suppression
    if (event.detail && event.detail.baseEvent === 'remove') {
      scheduleSynchronization(0);
    } else {
      // Pour les autres changements, utiliser un délai normal
      scheduleSynchronization(100);
    }
  }
  
  // Observer les liens vers le checkout
  function observeCheckoutLinks() {
    document.body.addEventListener('click', async function(e) {
      const target = e.target.closest('a[href="/checkout"], button[name="checkout"], [href*="checkout"], [onclick*="checkout"]');
      if (!target) return;
      
      // NOUVEAU: Vérifier si le panier ne contient que des échantillons sans bougies
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      if (cart && cart.items) {
        const hasBougies = cart.items.some(item => config.bougiesEligibles.includes(item.handle) || 
                                                  (item.product_type && item.product_type.toLowerCase().includes('bougie')));
        
        // Si le panier ne contient pas de bougies éligibles, autoriser le checkout sans validation
        if (!hasBougies) {
          log('✅ Pas de bougies dans le panier, checkout autorisé sans validation');
          return true;
        }
      }
      
      // Cas 1: Synchronisation en cours - bloquer et attendre
      if (isSynchronizing || kitsNeedSync) {
        log('🛑 Tentative de checkout bloquée pendant la synchronisation');
        e.preventDefault();
        e.stopPropagation();
        
        if (kitsNeedSync && !isSynchronizing) {
          synchronizeCart();
        }
        
        return false;
      }
      
      // Cas 2: Vérification anti-triche avant checkout
      const isValid = await validateCartBeforeCheckout();
      if (!isValid) {
        log('🛑 Checkout bloqué - panier corrigé');
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      // Si tout est correct, le checkout peut continuer normalement
      log('✅ Panier validé, checkout autorisé');
    }, true);
  }

  // Initialiser l'écoute des événements
  function initAutoKitBougies() {
    // Ne s'activer que sur les pages produits et le panier
    if (window.location.pathname.includes('/checkout')) {
      log('⏩ Page checkout détectée, script non activé');
      return;
    }

    // S'attacher aux événements d'ajout au panier et de modification du panier
    document.addEventListener('variant:add', handleProductAdded);
    document.addEventListener('cart:change', handleCartChange);
    
    // Observer les liens checkout pour appliquer la protection anti-triche
    observeCheckoutLinks();
    
    // Observer les changements dans le panier pour masquer les contrôles
    observeCartChanges();
    
    // Synchroniser le panier au chargement de la page
    scheduleSynchronization(50); // Synchronisation très rapide au chargement
    
    // NOUVEAU: Vérification périodique de l'intégrité du panier
    startPeriodicCartCheck();
    
    log('✓ Script auto-kit-bougies initialisé (avec protection anti-triche)');
  }
  
  // NOUVEAU: Vérification périodique du panier pour détecter les manipulations
  let cartCheckInterval = null;
  function startPeriodicCartCheck() {
    // Arrêter l'intervalle existant si présent
    if (cartCheckInterval) {
      clearInterval(cartCheckInterval);
    }
    
    // Vérifier le panier périodiquement (toutes les 15 secondes)
    cartCheckInterval = setInterval(async () => {
      // Éviter les vérifications si une synchronisation est déjà en cours
      if (isSynchronizing || document.hidden) return;
      
      try {
        const cart = await (await fetch('/cart.js')).json();
        if (!cart || !cart.items || cart.items.length === 0) return;
        
        // Vérifier intégrité des kits
        const kits = cart.items.filter(item => item.handle === config.kitHandle);
        if (kits.length > 0) {
          let needsResync = false;
          
          // Vérifier l'intégrité de chaque kit
          for (const kit of kits) {
            // Le prix doit être à 0
            if (parseFloat(kit.price) !== 0) {
              log(`⚠️ Détection périodique: Prix du kit manipulé (${kit.price})`);
              needsResync = true;
              break;
            }
            
            // Les propriétés doivent être correctes
            if (!kit.properties || !kit.properties._kit_offert) {
              log(`⚠️ Détection périodique: Propriétés du kit manipulées`);
              needsResync = true;
              break;
            }
          }
          
          // Vérifier le nombre de kits par rapport aux bougies
          const totalBougies = calculateTotalBougiesQuantity(cart.items);
          const totalKits = kits.reduce((sum, kit) => sum + kit.quantity, 0);
          
          if (totalBougies === 0 && totalKits > 0) {
            log(`⚠️ Détection périodique: Kits présents sans bougies`);
            needsResync = true;
          } else if (totalKits !== totalBougies) {
            log(`⚠️ Détection périodique: Nombre incorrect de kits (${totalKits} vs ${totalBougies})`);
            needsResync = true;
          }
          
          // Si besoin, forcer une synchronisation
          if (needsResync) {
            log(`🔄 Forçage de synchronisation suite à détection de manipulation`);
            synchronizeCart();
          }
        }
      } catch (error) {
        log(`❌ Erreur lors de la vérification périodique:`, error);
      }
    }, 15000); // Vérification toutes les 15 secondes
  }
})(); 